import { Dialog as HeadlessDialog, DialogBackdrop, DialogPanel } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/20/solid'
import { ReactNode } from 'react'
import { classNames } from '../_helpers'

type PropTypes = {
  children: ReactNode
  title: string | ReactNode
  open: boolean
  hideCloseButton?: boolean
  onClose: () => void
  separator?: boolean
  bottom?: boolean
  className?: string
}

export const Dialog = ({title, open, onClose, separator, hideCloseButton, children, className, bottom}: PropTypes) => (
  <HeadlessDialog open={open} as="div" className="relative z-10" onClose={onClose}>
    <DialogBackdrop
      transition
      className="fixed inset-0 bg-gray-500/75 transition-opacity data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in dark:bg-gray-900/50"
    />

    <div className="fixed inset-0 z-10 overflow-y-auto">
      <div className={classNames(
        'flex min-h-full justify-center p-4 text-center sm:p-0',
        bottom ? 'items-end' : 'items-center'
      )}>
        <DialogPanel
          transition
          className={classNames(
            'relative transform rounded-lg bg-white w-full px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:p-6',
            'transition-all data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in data-closed:sm:translate-y-0 data-closed:sm:scale-95',
            className ? className : 'sm:max-w-xl'
          )}
        >
          <div>
            <div className={'flex justify-between'}>
              <HeadlessDialog.Title as="h3" className="mb-3 text-lg text-center font-medium leading-6 text-gray-900">
                {title}
              </HeadlessDialog.Title>
              {!hideCloseButton && (
                <button onClick={onClose} className={'mb-3 focus:outline-none focus-visible:outline-none'}>
                  <XMarkIcon className={'w-5 h-5'} />
                </button>
              )}
            </div>

            {separator && (
              <div className={'h-4 mb-4 -mx-4 sm:-mx-6 bg-primary-300'} />
            )}

            {children}
          </div>
        </DialogPanel>
      </div>
    </div>
  </HeadlessDialog>
)
